<template>
  <div id="app">
    <Header />
    <router-view :key="$route.path" />
    <Footer />
  </div>
</template>

<script setup>
import Footer from './components/Footer.vue';
import Header from './components/Header.vue';

document.title = 'Slater Hamilton Accountants & Business Development';
</script>

<style>
#app {
  max-width: 1500px;
  margin: 0 auto;
}

/* Fonts */
@font-face {
  font-family: National;
  font-weight: 500;
  font-display: swap;
  src: url('https://api.slater.co.nz/v/3438f175-8429-4930-87b1-fc64ffea0292.woff2') format('woff2');
}
@font-face {
  font-family: National;
  font-weight: 600;
  font-display: swap;
  src: url('https://api.slater.co.nz/v/29ba2b38-733b-4785-aca6-6c5dcc9f6b5b.woff2') format('woff2');
}

/* Reset & base styles */
* {
  font-family: National, Helvetica, Arial, sans-serif;
  padding: 0;
  margin: 0;
  outline: none;
  box-sizing: border-box;
}

a {
  color: inherit;
  text-decoration: none;
}
</style>
